import React, { useContext, useState, useEffect } from "react";
import * as GrIcons from "react-icons/gr";

import LoadingSpinner from "../utilities/LoadingSpinner";

import UserContext from "../../context/users/userContext";

import CreateCharterAssignment from "./CreateCharterAssignments";

import UserPermissionReview from "./UserPermissionReview";

const UpdateUserPermissionModal = () => {
  const userContext = useContext(UserContext);
  const {
    setFormModal,
    user,
    clearFilteredCharters,
    filterCharters,
    getCharters,
    updateUser,
  } = userContext;
  const [newCharters, setNewCharters] = useState(
    Object.keys(user).length > 0 ? user.charterAssignments : []
  );
  const [newPermissionLevel, setNewPermissionLevel] = useState(
    Object.keys(user).length > 0 ? user.userStatus : ""
  );
  const [showCharterEdit, setShowCharterEdit] = useState(false);
  const [charterSearchText, setCharterSearchText] = useState("");
  const [newAllCharterAccess, setNewAllCharterAccess] = useState(
    Object.keys(user).length > 0 ? user.allCharterAccess : false
  );

  const handleOnCharterTextChange = (e) => {
    if (e.target.value === "") {
      clearFilteredCharters();
    } else {
      filterCharters(e.target.value);
    }
    setCharterSearchText(e.target.value);
  };

  const handleAssignCharter = (item) => {
    if (newCharters.some((e) => e._id === item._id)) {
    } else {
      setNewCharters([...newCharters, item]);
    }
  };

  const handleRemoveCharter = (index) => {
    setNewCharters(newCharters.filter((char, key) => key !== index));
  };

  const checkUserDataAssignmenets = () => {
    setNewCharters(Object.keys(user).length > 0 ? user.charterAssignments : []);
    setNewPermissionLevel(Object.keys(user).length > 0 ? user.userStatus : "");
    setNewAllCharterAccess(
      Object.keys(user).length > 0 ? user.allCharterAccess : false
    );
  };

  const resetValues = () => {
    checkUserDataAssignmenets();
    setCharterSearchText("");
    clearFilteredCharters();
  };

  const charterUpdateReady = newCharters.length > 0 && showCharterEdit;
  const permissionUpdateReady =
    !showCharterEdit &&
    (newCharters.length > 0 ||
      newPermissionLevel === "Super Admin" ||
      newPermissionLevel === "General") &&
    newPermissionLevel !== "";

  const handleConfirmButton = () => {
    if (charterUpdateReady) {
      setShowCharterEdit(false);
    }
    if (permissionUpdateReady) {
      const updatedUser = {
        charterAssignments: newCharters,
        userStatus: newPermissionLevel,
        userLevel:
          newPermissionLevel === "Admin"
            ? 3
            : newPermissionLevel === "User"
            ? 1
            : newPermissionLevel === "Contributor"
            ? 2
            : newPermissionLevel === "Super Admin"
            ? 4
            : 0,
        allCharterAccess: newAllCharterAccess,
      };
      updateUser(user._id, updatedUser);
      setFormModal("updateUserPermissionModal", false);
    }
  };

  const handleOnPermissionChange = (e) => {
    if (e.target.value === "Super Admin") {
      setNewAllCharterAccess(true);
    } else {
      setNewAllCharterAccess(false);
    }
    setNewPermissionLevel(e.target.value);
  };

  useEffect(() => {
    getCharters();
    checkUserDataAssignmenets();
    return () => {
      resetValues();
    };
  }, [user]);

  return (
    <div id="update-user-permission-modal" className="modal">
      <div className="update-user-permission-content modal-content">
        <div className="top-bar">
          <GrIcons.GrFormClose
            className="close-icon"
            onClick={() => setFormModal("updateUserPermissionModal", false)}
          />
          <h2>Update User Permission</h2>
        </div>
        <div className="modal-body">
          {Object.keys(user).length > 0 ? (
            showCharterEdit ? (
              <CreateCharterAssignment
                selectedUser={{
                  FirstName: user.name.split(" ")[0],
                  LastName: user.name.split(" ")[1],
                }}
                selectedCharters={newCharters}
                text={charterSearchText}
                handleOnChange={handleOnCharterTextChange}
                handleAssignCharter={handleAssignCharter}
                handleRemoveCharter={handleRemoveCharter}
                emptySelectedUser={() => setShowCharterEdit(false)}
              />
            ) : (
              <UserPermissionReview
                charters={newCharters}
                level={newPermissionLevel}
                charterAccess={newAllCharterAccess}
                setLevel={handleOnPermissionChange}
                setEdit={setShowCharterEdit}
                user={user}
              />
            )
          ) : (
            <LoadingSpinner />
          )}
        </div>
        <div className="bottom-bar">
          <div className="btns">
            <div
              onClick={() => handleConfirmButton()}
              className={`btn btn-llac-dark-${
                charterUpdateReady || permissionUpdateReady ? "green" : "grey"
              }`}
            >
              Confirm Site
            </div>
            <div
              className="btn btn-l4l-dark"
              onClick={() => setFormModal("updateUserPermissionModal", false)}
            >
              Close
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateUserPermissionModal;
